import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, numberAttribute } from '@angular/core';

@Component({
  selector: 'app-range-field',
  standalone: true,
  imports: [
    CommonModule,
  ],
  templateUrl: './range-field.component.html',
  styleUrl: './range-field.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RangeFieldComponent {
  @Input() label: string = '';
  @Input({ transform: numberAttribute }) minLimit?: number;
  @Input({ transform: numberAttribute }) min?: number;
  @Input({ transform: numberAttribute }) max?: number;
  @Input({ transform: numberAttribute }) maxLimit?: number;
}
